import React from 'react';
import { Helmet } from 'react-helmet';
import Content from '@component/common/content';
import Scroll from '@component/common/scroll';
import AppStart from '@component/gridgio/app-start';
import * as color from '@constant/color';

const StartPage: React.FC = () => (
  <Content top='var(--sat)' bottom='var(--sab)' backgroundColor={color.WHITE_1}>
    <Helmet>
      <title>시작하기 - GridGIO</title>
    </Helmet>
    <Scroll direction='y' height='100%'>
      <AppStart />
    </Scroll>
  </Content>
);

export default StartPage;
